import React, { Component } from 'react'
import './RodapeSite.scss'
import RodapeInstitucional from './RodapeInstitucional'
import FaleConosco from './FaleConosco'

class RodapeSite extends Component {
    render() {
        return (
            <div className="rodape">
                {/*
                <div className="acessoRapido">Acesso rápido</div>
                */}
                <div>
                    <FaleConosco />
                </div>
                <div>
                    <RodapeInstitucional />
                </div>
            </div>
        )
    }
}

export default RodapeSite
